// What the invoice uploaders accept. The BE pins invoices to PDF only
// (INVOICE_FILE_TYPE_REGEX), unlike SOA statements which also take photos.
//
// MIME-type-first for the same reason as statement-files.ts: `FileUploader`
// validates with `acceptedTypes.includes(file.type)`, and `File.type` is always
// a MIME type — an extension-only list rejects every file and `onUpload` never
// fires, which reads as a backend bug. The extension is additive: it only
// widens the browse dialog's filter.

/** Drives validation — must match `File.type` exactly. */
export const INVOICE_PDF_MIME_TYPE = 'application/pdf';

export const INVOICE_PDF_ACCEPT_TYPES: string[] = [INVOICE_PDF_MIME_TYPE, '.pdf'];

/** Matches the BE's MAX_FILE_SIZE_BYTES. FileUploader's own default is 5MB. */
export const MAX_INVOICE_FILE_SIZE = 10 * 1024 * 1024;
